(function() {
  if (window.LeonGroupifyVariants) return;

  function parseJson(id) {
    try {
      var el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  // Sortiert die Slider-Karten: verfuegbar zuerst, dann aufsteigend nach
  // Preis. Dieselbe Regel wie im Drawer.
  //
  // Muss ZWEIMAL laufen. Grund: Shopify liefert bei mehr als etwa 20
  // Lookups per all_products nicht fuer alle Handles ein Produkt. Fuer
  // diese rendert das Liquid optimistisch als verfuegbar, weil es den
  // echten Zustand nicht kennt. Erst hydratePendingCards holt ihn per
  // /products/{handle}.js nach und setzt is-oos. Lief die Sortierung nur
  // beim Init, standen genau diese ausverkauften Karten vorne.
  function sortSliderCards(viewport, init) {
    if (!viewport) return;
    var track = viewport.querySelector('.lgv__track');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.lgv__card'));
    if (cards.length <= 1) return;

    function parseCents(card) {
      var el = card.querySelector('.lgv__price');
      if (!el) return 0;
      // Noch nicht nachgeladene Preise ganz nach hinten innerhalb ihrer
      // Gruppe, damit ein Platzhalter nicht als 0 vorne einsortiert wird.
      if (el.getAttribute('data-lgv-price-pending') === 'true') return Number.MAX_SAFE_INTEGER;
      var txt = el.textContent.replace(/[€\s]/g, '').replace('.', '').replace(',', '.');
      return Math.round(parseFloat(txt) * 100) || 0;
    }

    // Stabil sortieren: bei gleichem Rang bleibt die Metafeld-Reihenfolge.
    // Array.sort ist in aktuellen Browsern stabil, der Index dient als
    // zusaetzliche Absicherung.
    var order = new Map();
    cards.forEach(function(c, i) { order.set(c, i); });

    cards.sort(function(a, b) {
      var aOos = a.classList.contains('is-oos') ? 1 : 0;
      var bOos = b.classList.contains('is-oos') ? 1 : 0;
      if (aOos !== bOos) return aOos - bOos;
      var d = parseCents(a) - parseCents(b);
      if (d !== 0) return d;
      return order.get(a) - order.get(b);
    });

    // Nichts anfassen, wenn die Reihenfolge schon stimmt. Verhindert einen
    // ueberfluessigen Reflow und ein Zurueckspringen der Scrollposition.
    var unveraendert = cards.every(function(c, i) { return order.get(c) === i; });
    if (unveraendert) return;

    var frag = document.createDocumentFragment();
    cards.forEach(function(c) { frag.appendChild(c); });
    track.appendChild(frag);

    // Nach dem Umsortieren an den Anfang. Die Scrollposition zu erhalten
    // waere schlechter: an derselben Pixelposition stehen danach andere
    // Karten, der Nutzer sieht also einen Sprung ohne erkennbaren Grund.
    // Das Nachladen ist ohnehin rund eine Sekunde nach dem Seitenaufbau
    // fertig, der Slider steht dann praktisch immer noch am Anfang.
    // V9.91: beim ersten Aufbau steht der Slider ohnehin am Anfang – scrollLeft setzen erzwang dort ein Layout der ganzen Seite
    if (!init) viewport.scrollLeft = 0;
    if (typeof viewport._lgvScheduleUpdate === 'function') viewport._lgvScheduleUpdate();
  }

  function bindSlider(root, uid) {
    var viewport = document.getElementById('lgv-viewport-' + uid);
    var prevBtn = document.getElementById('lgv-prev-' + uid);
    var nextBtn = document.getElementById('lgv-next-' + uid);
    var progress = document.getElementById('lgv-progress-' + uid);
    var rafId = null;
    var resizeTimer = null;

    if (!viewport || !progress || viewport.dataset.lgvInit) return;

    function updateUi() {
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      var visibleRatio = viewport.scrollWidth > 0 ? Math.min(1, viewport.clientWidth / viewport.scrollWidth) : 1;
      var trackWidth = progress.parentElement ? progress.parentElement.clientWidth : viewport.clientWidth;
      var progressWidth = trackWidth * visibleRatio;
      var desktop = window.innerWidth > 749;

      progress.style.width = progressWidth + 'px';
      progress.style.transform = 'translateX(' + (ratio * Math.max(0, trackWidth - progressWidth)) + 'px)';

      if (prevBtn) {
        var prevDisabled = viewport.scrollLeft <= 4;
        prevBtn.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
        prevBtn.tabIndex = prevDisabled ? -1 : 0;
        prevBtn.hidden = !desktop || maxScroll <= 4 || prevDisabled;
      }

      if (nextBtn) {
        var nextDisabled = viewport.scrollLeft >= maxScroll - 4;
        nextBtn.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
        nextBtn.tabIndex = nextDisabled ? -1 : 0;
        nextBtn.hidden = !desktop || maxScroll <= 4 || nextDisabled;
      }
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(function() {
        rafId = null;
        updateUi();
      });
    }

    function scrollBy(dir) {
      viewport.scrollBy({ left: Math.round(viewport.clientWidth * 0.82) * dir, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (prevBtn.getAttribute('aria-disabled') !== 'true') scrollBy(-1);
      });
      prevBtn.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && prevBtn.getAttribute('aria-disabled') !== 'true') {
          e.preventDefault();
          scrollBy(-1);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (nextBtn.getAttribute('aria-disabled') !== 'true') scrollBy(1);
      });
      nextBtn.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && nextBtn.getAttribute('aria-disabled') !== 'true') {
          e.preventDefault();
          scrollBy(1);
        }
      });
    }

    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleUpdate, 100);
    });

    viewport.dataset.lgvInit = '1';

    // Damit die Sortierung nach dem Nachladen der Verfügbarkeiten erneut
    // laufen kann, wird der UI-Refresh am Element hinterlegt. Ohne das
    // bliebe nach einem Umsortieren die Fortschrittsleiste und der
    // Zustand der Pfeile auf dem alten Stand.
    viewport._lgvScheduleUpdate = scheduleUpdate;

    sortSliderCards(viewport, true);

    if (typeof IntersectionObserver !== 'undefined') {
      var fired = false;
      var io = new IntersectionObserver(function(entries, observer) {
        if (entries[0].isIntersecting && !fired) {
          fired = true;
          observer.disconnect();
          updateUi();
        }
      }, { rootMargin: '200px' });
      io.observe(root);
      var rect = root.getBoundingClientRect();
      if (rect.top < window.innerHeight + 200 && !fired) {
        fired = true;
        updateUi();
      }
    } else {
      updateUi();
    }
  }

  /* TB V9.98 Varianten-Übersicht V2: Titel → Bestandteile (Pills), Abschnitte nach Akku-Anzahl, Filter, aktuelle Ausführung + Aufpreis,
     Größen-Gruppen als Raster. Erkennung auch für die Ausführungs-Kacheln der Produktseite (window.TBVP, tb-pdp.js).
     Nicht erkennbare Titel bleiben Text wie bisher. */
  function TX(k, fb, map) {
    var s = (window.TBT && window.TBT[k]) || fb;
    if (map) Object.keys(map).forEach(function(m) { s = String(s).split('%' + m + '%').join(map[m]); });
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var LROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function lr(u) { return (typeof u === 'string' && u.charAt(0) === '/' && u.charAt(1) !== '/' && LROOT !== '/' && u.indexOf(LROOT) !== 0) ? LROOT + u.slice(1) : u; }

  var ICO = {
    akku: '<rect width="16" height="10" x="2" y="7" rx="2"/><path d="M22 11v2M6 11v2M10 11v2"/>',
    lader: '<path d="M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"/><path d="m2 22 3-3M7.5 13.5 10 11M10.5 16.5 13 14M18 3l-4 4h6l-4 4"/>',
    koffer: '<path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/>',
    zub: '<path d="M16 16h6M19 13v6"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/>',
    solo: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
    mass: '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2M11.5 9.5 2-2M8.5 6.5l2-2M17.5 15.5l2-2"/>'
  };
  var CASES = [[/makpac/i, 'Makpac'], [/l-?boxx/i, 'L-Boxx'], [/systainer/i, 'Systainer'], [/t-?stak/i, 'T-STAK'], [/tough\s?system/i, 'ToughSystem'],
    [/packout/i, 'Packout'], [/metabox/i, 'metaBOX'], [/metaloc/i, 'MetaLoc'], [/hw-?case/i, 'HW-Case'], [/stackbox/i, 'Stackbox'],
    [/(transport)?koffer/i, ''], [/tasche/i, ''], [/\bcase\b/i, ''], [/\bbox\b/i, '']];
  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];
  var SIZE_RX = /^(?:gr(?:\.|ö(?:ß|ss)e|oesse)?\s*)?(xxs|xs|s|m|l|xl|xxl|xxxl|[2-6]xl|\d{2}(?:[\/-]\d{2})?|\d{2},5)$/i;

  function sizeOf(title) {
    var m = String(title || '').trim().match(SIZE_RX);
    return m ? m[1].toUpperCase() : '';
  }
  function sizeRank(s) {
    var i = SIZES.indexOf(s);
    if (i > -1) return i;
    var n = parseFloat(String(s).replace(',', '.'));
    return isNaN(n) ? 999 : 100 + n;
  }
  function ahNum(s) { return parseFloat(String(s).replace(',', '.')); }
  function ahTxt(s) { var n = ahNum(s); return isNaN(n) ? s : n.toFixed(1).replace('.', ','); }

  /* V9.99: segmentweise (getrennt an „+“, „,“, „ - “) – jedes Segment wird Akku / Lader / Koffer / Zubehör / Maß / frei */
  var ZUB = /tlg\.?|teilig|zubeh(ö|oe)r|\bbits?\b|bohrer|s(ä|ae)ge(blatt|bl(ä|ae)tter)|\bbl(ä|ae)tter\b|scheiben?\b|schleif|klingen?\b|aufsatz|vorsatz|adapter|spitzen?\b|meißel|meissel|\bset\b/i;
  function parseTitle(title, handle) {
    var raw = String(title || '').replace(/\s+/g, ' ').trim();
    var r = { raw: raw, akku: [], n: 0, solo: false, lader: false, koffer: '', zub: [], free: [], known: false, size: sizeOf(raw) };
    if (r.size) return r;
    if (/\bsolo\b/i.test(raw) || /ohne\s+akku/i.test(raw)) r.solo = true;
    raw.split(/\s*\+\s*|,\s+|\s+[-–]\s+|\s*\/\s*/).forEach(function(seg) {
      var s = seg.trim();
      if (!s || /^ohne\b/i.test(s)) return;
      s = s.replace(/\bsolo\b/ig, ' ').replace(/\bohne\s+.*$/i, ' ');
      s = s.replace(/(\d+)\s*[x×]\s*(?:akkus?\s*)?(\d+(?:[.,]\d+)?)\s*ah(?:\s*akkus?)?/ig, function(_, c, a) { r.akku.push({ c: +c, ah: ahTxt(a) }); return ' '; });
      s = s.replace(/(\d+(?:[.,]\d+)?)\s*ah(?:\s*akkus?)?/ig, function(_, a) { r.akku.push({ c: 1, ah: ahTxt(a) }); return ' '; });
      s = s.replace(/(\d+)\s*[x×]\s*akkus?\b/ig, function(_, c) { r.akku.push({ c: +c, ah: '' }); return ' '; });
      if (/(schnell|doppel)?lade(ger(ä|ae)t|r)\b|\bcharger\b/i.test(s)) { r.lader = true; s = s.replace(/(schnell|doppel)?lade(ger(ä|ae)t|r)\b|\bcharger\b/ig, ' '); }
      s = s.replace(/\s+/g, ' ').replace(/^[\s\-–·:]+|[\s\-–·:]+$/g, '').replace(/^(mit|inkl\.?|plus)\s+/i, '');
      if (!s || /^(akkus?|und|mit|inkl\.?|plus|&|im|in)$/i.test(s)) return;
      for (var i = 0; i < CASES.length; i++) {
        if (CASES[i][0].test(s)) {
          if (!r.koffer) r.koffer = CASES[i][1] || (s.length <= 22 ? s : TX('tb.vd.case', 'Koffer'));
          return;
        }
      }
      if (ZUB.test(s)) { r.zub.push(s.length <= 26 ? s : TX('tb.vd.acc', 'Zubehör')); return; }
      r.free.push(s);
    });
    /* V9.99: Titel schweigt, Handle sagt es (z. B. „Solo“ → …-systainer-ohne-akku-ohne-ladegerat) → Koffer/Lader/Akku aus dem Handle ergänzen */
    if (handle) {
      var h = String(handle).toLowerCase().replace(/(\d)-(\d)-ah/g, '$1,$2 ah').replace(/-/g, ' ');
      var hs = h.replace(/\bohne\s+\S+/g, ' ');
      if (!r.koffer) for (var j = 0; j < CASES.length; j++) { if (CASES[j][0].test(hs)) { r.koffer = CASES[j][1] || TX('tb.vd.case', 'Koffer'); break; } }
      if (!r.lader && /ladegerat|ladegeraet|\blader\b/.test(hs)) r.lader = true;
      if (!r.akku.length && !r.solo) {
        hs.replace(/(\d+)\s*x\s*akkus?\s*(\d+,\d+)\s*ah/g, function(_, c, a) { r.akku.push({ c: +c, ah: ahTxt(a) }); return ' '; });
        if (!r.akku.length && /ohne akku/.test(h)) r.solo = true;
      }
    }
    r.akku.forEach(function(a) { r.n += a.c; });
    if (r.n > 0) r.solo = false;
    r.known = !!(r.akku.length || r.solo || r.lader || r.koffer || r.zub.length);
    return r;
  }

  function pill(kind, txt) {
    var ic = ICO[kind] ? '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICO[kind] + '</svg>' : '';
    return '<span class="tb-vp__p tb-vp__p--' + kind + '">' + ic + esc(txt) + '</span>';
  }
  /* Pills eines Titels; null = als Text zeigen */
  function pillsHtml(p, mode) {
    if (!p || p.size) return null;
    var h = [];
    if (mode === 'kit') {
      if (p.n === 0 && p.solo) h.push(pill('solo', TX('tb.vd.solo', 'Nur Gerät')));
      p.akku.forEach(function(a) { h.push(pill('akku', a.c + '× ' + (a.ah ? a.ah + ' Ah' : TX('tb.vd.akku', 'Akku')))); });
      if (p.lader) h.push(pill('lader', TX('tb.vd.charger_short', 'Lader')));
      if (p.koffer) h.push(pill('koffer', p.koffer));
      p.zub.forEach(function(z) { h.push(pill('zub', z)); });
    }
    var free = mode === 'kit' ? p.free : (p.free.length ? p.free : [p.raw]);
    if (free.length > 3 || free.some(function(f) { return f.length > 26; })) return null;
    free.forEach(function(f) { h.push(pill(/\d\s?(mm|cm|m|kg|g|l|ml|v|w|nm|zoll|")(\b|$)|ø/i.test(f) ? 'mass' : 'frei', f)); });
    return h.length ? h.join('') : null;
  }
  function groupMode(parsed) {
    if (!parsed.length) return 'text';
    if (parsed.every(function(p) { return p.size; })) return 'size';
    var k = parsed.filter(function(p) { return p.known; }).length;
    if (k * 2 >= parsed.length) return 'kit';
    return 'free';
  }
  window.TBVP = { parse: parseTitle, mode: groupMode, pills: pillsHtml, sizeRank: sizeRank };

  // Formatiert einen Cent-Betrag im Shopify-Format (€19,70)
  /* V9.98: Währung/Format der Seitensprache (vorher fest „€“, falsch z. B. auf CHF/DKK) */
  function formatMoney(cents) {
    if (!cents) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  // Extrahiert den Produkt-Handle aus einer /products/... URL
  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  // Globaler Preis-Cache: verhindert Re-Fetches wenn Drawer erneut geöffnet wird
  var lgvPriceCache = {};

  /* Lädt fehlende Preise/Verfügbarkeit (all_products-Leck) mit max. 4 parallelen Abrufen, danach einmal neu zeichnen */
  function loadMissing(items, done) {
    var pending = [];
    items.forEach(function(it) {
      if (it.price > 0) return;
      var c = lgvPriceCache[it.handle];
      if (c) { if (c.gone) it.gone = true; else { it.price = c.price; it.available = c.available; } }
      else pending.push(it);
    });
    if (!pending.length) { done(); return; }
    var i = 0, open = pending.length;
    function fin() { if (--open <= 0) done(); }
    function next() {
      if (i >= pending.length) return;
      var it = pending[i++];
      fetch(lr('/products/' + it.handle + '.js'))
        .then(function(r) { return r.ok ? r.json() : (r.status === 404 ? { gone: true } : null); })
        .then(function(d) {
          if (d && d.gone) { it.gone = true; lgvPriceCache[it.handle] = { gone: true }; }
          else if (d) { it.price = d.price_min || d.price || 0; it.available = d.available; lgvPriceCache[it.handle] = { price: it.price, available: it.available }; if (!it.image && d.featured_image) it.image = d.featured_image + (d.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
          fin(); next();
        })
        .catch(function() { fin(); next(); });
    }
    for (var k = 0; k < Math.min(4, pending.length); k++) next();
  }

  function buildDrawerCss(id) {
    var D = '#' + id;
    return [
      D + ' *{box-sizing:border-box}',
      D + ' .lgv-v-sub{margin:2px 0 0;font:400 13px/1.3 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink-2,#6b6b73)}',
      D + ' .lgv-v-filt{display:flex;flex-direction:column;gap:8px;padding:0 16px 12px;border-bottom:1px solid var(--tb-line,#ecedec);flex-shrink:0}',
      D + ' .lgv-v-fr{display:flex;align-items:center;gap:6px;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
      D + ' .lgv-v-fr::-webkit-scrollbar{display:none}',
      D + ' .lgv-v-fl{flex:none;min-width:40px;font:600 12px/1 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink-2,#6b6b73)}',
      D + ' .lgv-v-chip{all:unset;box-sizing:border-box;flex:none;display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 12px;border:1px solid #d9d9de;border-radius:999px;background:#fff;font:500 13px/1 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink,#323232);cursor:pointer;float:none!important;min-width:0!important;white-space:nowrap}',
      D + ' .lgv-v-chip::before,' + D + ' .lgv-v-chip::after{display:none!important}',
      D + ' .lgv-v-chip svg{width:14px;height:14px}',
      D + ' .lgv-v-chip[aria-pressed="true"]{background:var(--tb-ink,#323232);border-color:var(--tb-ink,#323232);color:#fff;font-weight:600}',
      D + ' .lgv-v-chip:focus-visible{outline:2px solid var(--tb-action,#1e71e2);outline-offset:2px}',
      D + ' .lgv-v-sec{margin:0;padding:14px 16px 6px;font:700 11px/1 var(--main_ff,"DM Sans"),sans-serif;letter-spacing:.06em;text-transform:uppercase;color:var(--tb-ink-2,#6b6b73)}',
      D + ' .lgv-v-row{display:flex;align-items:center;gap:12px;padding:10px 16px;color:var(--tb-ink,#323232)!important;text-decoration:none!important;position:relative;transition:background .15s}',
      D + ' .lgv-v-row:hover{background:var(--tb-bg-2,#f5f5f7)}',
      D + ' .lgv-v-row:focus-visible{outline:2px solid var(--tb-action,#1e71e2);outline-offset:-2px}',
      D + ' .lgv-v-row.is-cur{background:var(--tb-blue-50,#f2f7fe)}',
      D + ' .lgv-v-row.is-cur::before{content:"";position:absolute;left:0;top:10px;bottom:10px;width:3px;border-radius:0 2px 2px 0;background:var(--tb-action,#1e71e2)}',
      D + ' .lgv-v-row.is-oos{opacity:.55}',
      D + ' .lgv-v-img{flex:none;width:48px;height:48px;border-radius:8px;background:var(--tb-bg-2,#f5f5f7);overflow:hidden;display:flex;align-items:center;justify-content:center}',
      D + ' .lgv-v-img img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}',
      D + ' .lgv-v-mid{flex:1;min-width:0;display:flex;flex-direction:column;gap:5px}',
      D + ' .lgv-v-t{font:400 13px/1.35 var(--main_ff,"DM Sans"),sans-serif;overflow-wrap:anywhere}',
      D + ' .lgv-v-cur{font:600 11px/1 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-action,#1e71e2)}',
      D + ' .lgv-v-pr{flex:none;text-align:right;display:flex;flex-direction:column;gap:3px;align-items:flex-end}',
      D + ' .lgv-v-p{font:700 15px/1.1 var(--main_ff,"DM Sans"),sans-serif;white-space:nowrap}',
      D + ' .lgv-v-d{font:400 11px/1 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink-2,#6b6b73);white-space:nowrap}',
      D + ' .lgv-v-d.is-less{color:#16a34a}',
      D + '.lgv-d--desk .lgv-v-filt{padding:14px 20px 16px;gap:10px}',
      D + '.lgv-d--desk .lgv-v-fr{flex-wrap:wrap;overflow:visible;row-gap:8px;position:relative;padding-left:56px}',
      D + '.lgv-d--desk .lgv-v-fl{position:absolute;left:0;top:9px;min-width:0}',
      D + '.lgv-d--desk .lgv-v-chip{height:30px;padding:0 11px}',
      D + '.lgv-d--desk .lgv-v-row{padding:10px 20px}',
      D + '.lgv-d--desk .lgv-v-sec{padding:16px 20px 6px}',
      D + ' .lgv-v-empty{padding:28px 16px;text-align:center;font:400 14px/1.4 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink-2,#6b6b73)}',
      D + ' .lgv-v-empty .lgv-v-chip{margin-top:10px}',
      D + ' .lgv-v-size{display:grid;grid-template-columns:repeat(auto-fill,minmax(72px,1fr));gap:8px;padding:16px}',
      D + ' .lgv-v-sz{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;height:58px;border:1px solid #d9d9de;border-radius:8px;background:#fff;color:var(--tb-ink,#323232)!important;text-decoration:none!important}',
      D + ' .lgv-v-sz b{font:700 15px/1 var(--main_ff,"DM Sans"),sans-serif}',
      D + ' .lgv-v-sz span{font:400 11px/1 var(--main_ff,"DM Sans"),sans-serif;color:var(--tb-ink-2,#6b6b73)}',
      D + ' .lgv-v-sz:hover{border-color:var(--tb-action,#1e71e2)}',
      D + ' .lgv-v-sz.is-cur{border:2px solid var(--tb-action,#1e71e2);background:var(--tb-blue-50,#f2f7fe)}',
      D + ' .lgv-v-sz.is-cur b{color:var(--tb-action,#1e71e2)}',
      D + ' .lgv-v-sz.is-oos{border-style:dashed;background:var(--tb-bg-2,#f5f5f7)}',
      D + ' .lgv-v-sz.is-oos b{color:#9a9aa2;text-decoration:line-through}'
    ].join('');
  }

  /* Liste/Raster aus dem Datenmodell zeichnen (auch nach dem Nachladen und bei jedem Filterwechsel) */
  function renderOverview(st, t) {
    var items = st.items.filter(function(it) { return !it.gone; });
    var cur = items.filter(function(it) { return it.current; })[0];
    var avail = items.filter(function(it) { return it.available !== false && it.price > 0; });
    var min = avail.length ? Math.min.apply(null, avail.map(function(it) { return it.price; })) : 0;
    st.sub.textContent = st.mode === 'size' ? TX('tb.vd.sizes', '%count% Größen', { count: items.length })
      : min ? TX('tb.vd.sub', '%count% Ausführungen · ab %price%', { count: items.length, price: formatMoney(min) })
      : TX('tb.vd.sub_n', '%count% Ausführungen', { count: items.length });
    var body = st.list;
    if (st.mode === 'size') {
      items.sort(function(a, b) { return sizeRank(a.p.size) - sizeRank(b.p.size); });
      body.innerHTML = '<div class="lgv-v-size">' + items.map(function(it) {
        var oos = it.available === false;
        return '<a class="lgv-v-sz' + (it.current ? ' is-cur' : '') + (oos ? ' is-oos' : '') + '" href="' + esc(lr(it.url)) + '"' + (it.current ? ' aria-current="page"' : '') + (oos ? ' aria-label="' + esc(it.p.size + ' – ' + TX('tb.product.sold_out_short', 'ausverkauft')) + '"' : '') + '><b>' + esc(it.p.size) + '</b><span>' + (oos ? esc(TX('tb.product.sold_out_short', 'ausverkauft')) : esc(it.price ? formatMoney(it.price) : '–')) + '</span></a>';
      }).join('') + '</div>';
      return;
    }
    var f = st.f;
    var vis = items.filter(function(it) {
      if (it.current) return true;
      var p = it.p;
      if (f.ah === 'none' && p.n !== 0) return false;
      if (f.ah !== 'all' && f.ah !== 'none' && !p.akku.some(function(a) { return a.ah === f.ah; })) return false;
      if (f.lader && !p.lader) return false;
      if (f.koffer && !p.koffer) return false;
      if (f.zub && !p.zub.length) return false;
      return true;
    });
    vis.sort(function(a, b) {
      if (st.mode === 'kit' && a.p.n !== b.p.n) return a.p.n - b.p.n;
      if (a.current !== b.current) return a.current ? -1 : 1;
      var ao = a.available === false ? 1 : 0, bo = b.available === false ? 1 : 0;
      if (ao !== bo) return ao - bo;
      return (a.price || 9e9) - (b.price || 9e9);
    });
    var secs = {};
    vis.forEach(function(it) { secs[it.p.n] = 1; });
    var showSec = st.mode === 'kit' && Object.keys(secs).length > 1;
    var last = null, h = [];
    vis.forEach(function(it) {
      if (showSec && it.p.n !== last) {
        last = it.p.n;
        h.push('<p class="lgv-v-sec">' + esc(last === 0 ? TX('tb.vd.solo', 'Nur Gerät') : last === 1 ? TX('tb.vd.sec_one', '1 Akku') : TX('tb.vd.sec_n', '%n% Akkus', { n: last })) + '</p>');
      }
      var oos = it.available === false;
      var ph = pillsHtml(it.p, st.mode);
      var d = '';
      if (oos) d = '<span class="lgv-v-d">' + esc(TX('tb.product.sold_out_short', 'ausverkauft')) + '</span>';
      else if (cur && !it.current && cur.price && it.price && it.price !== cur.price) {
        var diff = it.price - cur.price;
        d = '<span class="lgv-v-d' + (diff < 0 ? ' is-less' : '') + '">' + (diff > 0 ? '+' : '−') + formatMoney(Math.abs(diff)) + '</span>';
      }
      h.push('<a class="lgv-v-row' + (it.current ? ' is-cur' : '') + (oos ? ' is-oos' : '') + '" href="' + esc(lr(it.url)) + '"' + (it.current ? ' aria-current="page"' : '') + '>'
        + '<span class="lgv-v-img">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy" decoding="async" width="48" height="48">' : '') + '</span>'
        + '<span class="lgv-v-mid">' + (ph ? '<span class="tb-vp">' + ph + '</span>' : '<span class="lgv-v-t">' + esc(it.title) + '</span>')
        + (it.current ? '<span class="lgv-v-cur">' + esc(TX('tb.vd.current', 'Aktuell angesehen')) + '</span>' : '') + '</span>'
        + '<span class="lgv-v-pr"><span class="lgv-v-p">' + (it.price ? formatMoney(it.price) : '–') + '</span>' + d + '</span></a>');
    });
    if (vis.filter(function(it) { return !it.current; }).length === 0) {
      h.push('<div class="lgv-v-empty">' + esc(TX('tb.vd.empty', 'Keine Ausführung passt zu diesen Filtern.')) + '<br><button type="button" class="lgv-v-chip" data-lgv-reset>' + esc(TX('tb.vd.reset', 'Filter zurücksetzen')) + '</button></div>');
    }
    body.innerHTML = h.join('');
  }

  /* Filter nur, wenn sie die Liste wirklich teilen */
  function buildFilters(st) {
    if (st.mode !== 'kit') return '';
    var items = st.items.filter(function(it) { return !it.current && !it.gone; });
    if (items.length < 6) return '';
    var ahs = {}, none = false, lad = 0, kof = 0, zub = 0;
    items.forEach(function(it) {
      if (it.p.n === 0) none = true;
      it.p.akku.forEach(function(a) { if (a.ah) ahs[a.ah] = 1; });
      if (it.p.lader) lad++;
      if (it.p.koffer) kof++;
      if (it.p.zub.length) zub++;
    });
    var opts = Object.keys(ahs).sort(function(a, b) { return ahNum(a) - ahNum(b); });
    var h = '';
    if (opts.length + (none ? 1 : 0) >= 2) {
      h += '<div class="lgv-v-fr" role="group" aria-label="' + esc(TX('tb.vd.akku', 'Akku')) + '"><span class="lgv-v-fl">' + esc(TX('tb.vd.akku', 'Akku')) + '</span>'
        + '<button type="button" class="lgv-v-chip" data-lgv-ah="all" aria-pressed="true">' + esc(TX('tb.vd.all', 'Alle')) + '</button>'
        + (none ? '<button type="button" class="lgv-v-chip" data-lgv-ah="none" aria-pressed="false">' + esc(TX('tb.vd.none', 'Ohne')) + '</button>' : '')
        + opts.map(function(a) { return '<button type="button" class="lgv-v-chip" data-lgv-ah="' + esc(a) + '" aria-pressed="false">' + esc(a) + ' Ah</button>'; }).join('') + '</div>';
    }
    var tg = '';
    if (lad && lad < items.length) tg += '<button type="button" class="lgv-v-chip" data-lgv-t="lader" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICO.lader + '</svg>' + esc(TX('tb.vd.charger', 'Ladegerät')) + '</button>';
    if (kof && kof < items.length) tg += '<button type="button" class="lgv-v-chip" data-lgv-t="koffer" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICO.koffer + '</svg>' + esc(TX('tb.vd.case', 'Koffer')) + '</button>';
    if (zub && zub < items.length) tg += '<button type="button" class="lgv-v-chip" data-lgv-t="zub" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICO.zub + '</svg>' + esc(TX('tb.vd.acc', 'Zubehör')) + '</button>';
    if (tg) h += '<div class="lgv-v-fr" role="group" aria-label="' + esc(TX('tb.vd.incl', 'Dabei')) + '"><span class="lgv-v-fl">' + esc(TX('tb.vd.incl', 'Dabei')) + '</span>' + tg + '</div>';
    return h ? '<div class="lgv-v-filt">' + h + '</div>' : '';
  }

  function initDrawer(root, uid, t) {
    var trigger = document.getElementById('lgv-ov-trigger-' + uid);
    if (!trigger || trigger.dataset.lgvDrawerInit) return;

    var drawer = null;
    var overlay = null;
    var drawerBuilt = false;
    var DRAWER_ID = 'lgv-drawer-' + uid;
    var OVERLAY_ID = 'lgv-overlay-' + uid;

    function buildDrawer() {
      if (drawerBuilt) return;
      drawerBuilt = true;

      var data = parseJson('lgv-data-' + uid);
      var isMobile = window.innerWidth <= 749;
      /* V9.98 Datenmodell: jede Zeile einmal erkennen, Modus je Gruppe (Größen / Akku-Sets / frei) */
      var st = { items: (data.items || []).map(function(it) { return { title: it.title || it.handle || '', url: it.url || ('/products/' + (it.handle || '')), handle: it.handle || handleFromUrl(it.url), price: it.price || 0, available: it.available !== false, image: it.image || '', current: !!it.current, p: parseTitle(it.title, it.handle || handleFromUrl(it.url)) }; }), f: { ah: 'all', lader: false, koffer: false, zub: false } };
      st.mode = groupMode(st.items.map(function(it) { return it.p; }));
      var filtHtml = buildFilters(st);

      overlay = document.createElement('div');
      overlay.id = OVERLAY_ID;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'lgv-d-overlay';
      /* TB V9.10: Desktop wie die Warenkorb-Schublade (leichte Abdunklung, kein Weichzeichner) */
      overlay.style.cssText = [
        'position:fixed','inset:0','background:' + (isMobile ? 'rgba(0,0,0,0.42)' : 'rgba(0,0,0,0.16)'),
        'z-index:9000','opacity:0','visibility:hidden',
        'transition:opacity .32s cubic-bezier(.4,0,.2,1),visibility .32s cubic-bezier(.4,0,.2,1)',
        isMobile ? '-webkit-backdrop-filter:blur(2px)' : '', isMobile ? 'backdrop-filter:blur(2px)' : ''
      ].filter(Boolean).join(';');

      drawer = document.createElement('aside');
      drawer.id = DRAWER_ID;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-labelledby', 'lgv-d-title-' + uid);
      drawer.style.cssText = isMobile ? [
        'position:fixed',
        'top:8px','bottom:8px','left:8px','right:8px',
        'width:calc(100vw - 16px)',
        'height:calc(100dvh - 16px)',
        'max-height:calc(100dvh - 16px)',
        'background:#fff',
        'z-index:9001','display:flex','flex-direction:column',
        'transform:translateY(calc(100vh + 20px))',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'border-radius:16px',
        'overflow:hidden','font-family:"DM Sans",sans-serif',
        'box-shadow:0 4px 32px rgba(0,0,0,0.22)'
      ].join(';') : [
        'position:fixed','top:0','right:0','bottom:0',
        'width:min(460px,100vw)','background:#fff',
        'z-index:9001','display:flex','flex-direction:column',
        'transform:translateX(100%)',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'overflow:hidden','font-family:"DM Sans",sans-serif',
        'box-shadow:-4px 0 24px rgba(0,0,0,0.12)'
      ].join(';');

      /* TB V9.10 Desktop: Kopf wie Warenkorb-Schublade – kein Zieh-Strich, 56 px Kopf mit Linie, Titel 17 px + Anzahl, Schließen 40 px */

      var cb = isMobile ? 32 : 40;
      if (!isMobile) drawer.classList.add('lgv-d--desk');
      drawer.innerHTML = [
        isMobile ? '<div style="display:flex;justify-content:center;padding:10px 0 0;flex-shrink:0;"><div style="width:36px;height:4px;background:rgba(0,0,0,0.15);border-radius:99px;"></div></div>' : '',
        isMobile ? '<div style="display:flex;align-items:center;justify-content:space-between;padding:14px 20px 14px;flex-shrink:0;">' : '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:56px;padding:8px 12px 8px 20px;flex-shrink:0;border-bottom:1px solid #ebebf0;">',
          '<div style="min-width:0;"><h2 id="lgv-d-title-' + uid + '" style="margin:0;font-size:' + (isMobile ? '17px' : '18px') + ';font-weight:400;line-height:1.2;color:var(--tb-ink,#323232);font-family:var(--main_ff_h,inherit);">' + esc(data.label || '') + '</h2><p class="lgv-v-sub" id="lgv-d-sub-' + uid + '"></p></div>',
          '<button id="lgv-d-close-' + uid + '" type="button" aria-label="' + t.close_btn + '" style="display:flex!important;align-items:center!important;justify-content:center!important;width:' + cb + 'px!important;min-width:' + cb + 'px!important;max-width:' + cb + 'px!important;height:' + cb + 'px!important;min-height:' + cb + 'px!important;max-height:' + cb + 'px!important;border:none!important;background:' + (isMobile ? 'rgba(0,0,0,0.06)' : '#f5f5f7') + '!important;border-radius:50%!important;cursor:pointer!important;color:' + (isMobile ? '#555' : '#323240') + '!important;transition:background .18s!important;flex-shrink:0!important;padding:0!important;margin:0!important;box-sizing:content-box!important;appearance:none!important;-webkit-appearance:none!important;box-shadow:none!important;">',
            '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
        '</div>',
        '<style>' + buildDrawerCss(DRAWER_ID) + '</style>',
        filtHtml,
        '<div id="lgv-d-body-' + uid + '" style="flex:1;overflow-y:auto;overscroll-behavior:contain;padding:0 0 12px;"></div>'
      ].join('');

      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      st.list = document.getElementById('lgv-d-body-' + uid);
      st.sub = document.getElementById('lgv-d-sub-' + uid);
      renderOverview(st, t);
      // Preise nachladen für Items, die im Liquid nicht aufgelöst wurden, danach einmal neu zeichnen
      loadMissing(st.items, function() { renderOverview(st, t); });
      drawer.addEventListener('click', function(e) {
        var b = e.target.closest('button[data-lgv-ah],button[data-lgv-t],button[data-lgv-reset]');
        if (!b || !drawer.contains(b)) return;
        if (b.hasAttribute('data-lgv-reset')) { st.f = { ah: 'all', lader: false, koffer: false, zub: false }; }
        else if (b.hasAttribute('data-lgv-ah')) { st.f.ah = b.getAttribute('data-lgv-ah'); }
        else { var k = b.getAttribute('data-lgv-t'); st.f[k] = !st.f[k]; }
        drawer.querySelectorAll('button[data-lgv-ah]').forEach(function(x) { x.setAttribute('aria-pressed', x.getAttribute('data-lgv-ah') === st.f.ah ? 'true' : 'false'); });
        drawer.querySelectorAll('button[data-lgv-t]').forEach(function(x) { x.setAttribute('aria-pressed', st.f[x.getAttribute('data-lgv-t')] ? 'true' : 'false'); });
        renderOverview(st, t);
      });

      var closeBtn = document.getElementById('lgv-d-close-' + uid);
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
        closeBtn.addEventListener('mouseover', function() {
          closeBtn.style.setProperty('background', isMobile ? 'rgba(0,0,0,.12)' : '#ebebf0', 'important');
        });
        closeBtn.addEventListener('mouseout', function() {
          closeBtn.style.setProperty('background', isMobile ? 'rgba(0,0,0,.06)' : '#f5f5f7', 'important');
        });
      }

      overlay.addEventListener('click', closeDrawer);

      drawer.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(drawer.querySelectorAll('button:not([disabled]),[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      });
    }

    function openDrawer() {
      buildDrawer();
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.pointerEvents = 'auto';
      overlay.setAttribute('aria-hidden', 'false');
      drawer.style.setProperty('transform', 'none', 'important');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        var cb = document.getElementById('lgv-d-close-' + uid);
        if (cb) cb.focus();
      }, 360);
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      drawer.style.setProperty('transform', window.innerWidth <= 749 ? 'translateY(calc(100vh + 20px))' : 'translateX(100%)', 'important');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      trigger.focus();
    }

    // FIX: -webkit-line-clamp Hit-Test Bug (Chrome/WebKit)
    // Der Titellink <a> im <h3> hat visuell 2 Zeilen (39px), aber sein
    // Hit-Test-Bereich erstreckt sich auf die volle scrollHeight (58px+).
    // Das überdeckt den Button darunter vollständig.
    // Lösung: pointer-events:none auf den h3-Link; click-delegation auf dem
    // h3 selbst navigiert weiterhin zur Produktseite.
    var card = trigger.closest('.leon-product-card');
    if (card) {
      var titleLink = card.querySelector('.leon-product-card__body h3 a');
      var cardBody = card.querySelector('.leon-product-card__body');
      if (titleLink) {
        // Link-Hit-Test deaktivieren (webkit-line-clamp Bug: der Link-Klickbereich
        // ist größer als der sichtbare Text und würde den Button blockieren)
        titleLink.style.pointerEvents = 'none';
      }
      // Den gesamten Card-Body klickbar machen (ersetzt den natürlichen Link-Klickbereich).
      // So ist die Karte überall klickbar – konsistent mit Karten ohne Varianten-Trigger.
      if (cardBody && !cardBody.dataset.lgvNavInit) {
        cardBody.dataset.lgvNavInit = '1';
        cardBody.style.cursor = 'pointer';
        cardBody.addEventListener('click', function(e) {
          // Klicks auf interaktive Elemente nicht abfangen:
          // Drawer-Button, ATC-Button, Links (Rating, Lieferzeit etc.)
          if (e.target.closest('[data-lgv-drawer-root]')) return;
          if (e.target.closest('a[href]')) return;
          if (e.target.closest('button:not(.leon-variant-badge--trigger)')) return;
          if (e.target.closest('input, select, form')) return;
          var href = titleLink ? titleLink.getAttribute('href') : null;
          if (href) window.location.href = href;
        });
      }
    }

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });

    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });

    trigger.dataset.lgvDrawerInit = '1';
  }

  function init(root) {
    if (!root || root.dataset.lgvBooted) return;
    root.dataset.lgvBooted = '1';

    var uid = root.getAttribute('data-lgv-uid');
    var t = parseJson('lgv-locale-' + uid);
    t.overview_btn = t.overview_btn || 'Übersicht';
    t.close_btn = t.close_btn || 'Schließen';
    t.col_variant = t.col_variant || 'Variante';
    t.col_price = t.col_price || 'Preis';
    t.col_avail = t.col_avail || 'Verfügbarkeit';
    t.available = t.available || 'Auf Lager';
    t.unavailable = t.unavailable || 'Nicht verfügbar';
    t.view_product = t.view_product || 'Ansehen';
    t.count = t.count || '';

    var btnLabel = document.getElementById('lgv-ov-btn-label-' + uid);
    if (btnLabel) btnLabel.textContent = t.overview_btn;

    if (root.hasAttribute('data-lgv-root')) {
      bindSlider(root, uid);
      // BUG-FIX (Shopify all_products 20-Item-Limit-Leak):
      // Karten ohne validen Lookup haben `data-lgv-price-pending="true"`.
      // Wir laden ihre Preise/Verfügbarkeit per /products/{handle}.js nach.
      // Nutzt denselben lgvPriceCache wie der Drawer – kein doppelter Fetch.
      hydratePendingCards(root);
    }
    initDrawer(root, uid, t);
  }

  // Lädt Preise für Cards mit data-lgv-price-pending (Leak-Detection im Liquid).
  // Verwendet denselben Cache wie Drawer für minimale Network-Calls.
  function hydratePendingCards(root) {
    var pendingPrices = root.querySelectorAll('.lgv__price[data-lgv-price-pending="true"]');
    if (!pendingPrices.length) return;

    // Sammle alle pending Cards group-by handle
    var byHandle = {};
    pendingPrices.forEach(function(priceEl) {
      var card = priceEl.closest('.lgv__card');
      if (!card) return;
      var handle = card.getAttribute('data-lgv-handle');
      if (!handle) return;
      if (!byHandle[handle]) byHandle[handle] = [];
      byHandle[handle].push(card);
    });

    function applyToCard(card, data) {
      var priceEl = card.querySelector('.lgv__price');
      if (!priceEl) return;
      if (!data) {
        // Network-Fehler: zeige neutralen Platzhalter, kein Preis
        priceEl.removeAttribute('data-lgv-price-pending');
        return;
      }
      var price = data.price || data.price_min || 0;
      if (price) {
        priceEl.textContent = formatMoney(price);
      }
      priceEl.removeAttribute('data-lgv-price-pending');

      // Vendor nachfüllen, falls leer
      var vendorEl = card.querySelector('.lgv__vendor');
      if (vendorEl && !vendorEl.textContent.trim() && data.vendor) {
        vendorEl.textContent = data.vendor;
      }

      // OOS-Status: Wenn nicht verfügbar, Karte als OOS markieren.
      //
      // Frueher blieben diese Karten bewusst an ihrer Position, um kein
      // Umsortieren nach dem Laden auszuloesen. Das fuehrte aber dazu,
      // dass ausverkaufte Varianten vorne standen – die Karten aus dem
      // all_products-Leak werden vom Liquid als verfuegbar gerendert und
      // landeten damit in der vorderen Gruppe. Deshalb wird nach dem
      // Nachladen jetzt neu sortiert (siehe sortAfterHydrate unten).
      if (data.available === false) {
        card.classList.add('is-oos');
        var oosLabel = (card.querySelector('.lgv__item-title') || {}).textContent || '';
        card.setAttribute('aria-label', ((window.TBT && window.TBT['tb.a11y.unavailable_named']) || '%title%').split('%title%').join(oosLabel));
      }
    }

    // Nach Abschluss aller Nachladungen einmal neu sortieren, damit die
    // inzwischen als ausverkauft erkannten Karten nach hinten wandern.
    // Einmal am Ende statt nach jeder Antwort – sonst springt die Reihe
    // bei jedem eintreffenden Request.
    var viewport = root.querySelector('.lgv__viewport');
    function sortAfterHydrate() {
      sortSliderCards(viewport);
    }

    // Max 4 concurrent Requests
    var pending = [];
    Object.keys(byHandle).forEach(function(handle) {
      if (lgvPriceCache[handle]) {
        var cached = lgvPriceCache[handle];
        byHandle[handle].forEach(function(card) {
          if (cached.gone) { (card.closest('.lgv__card') || card).remove(); return; }
          applyToCard(card, { price: cached.price, available: cached.available });
        });
      } else {
        pending.push(handle);
      }
    });

    if (!pending.length) {
      // Alles kam aus dem Cache: direkt sortieren.
      sortAfterHydrate();
      return;
    }

    var CONCURRENCY = 4;
    var idx = 0;
    var offen = pending.length;

    function erledigt() {
      offen -= 1;
      if (offen <= 0) sortAfterHydrate();
    }

    function next() {
      if (idx >= pending.length) return;
      var handle = pending[idx++];
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : (r.status === 404 ? { gone: true } : null); })
        .then(function(data) {
          /* V9.69: 404 → Karte entfernen (Produkt nicht im Shop) */
          if (data && data.gone) {
            lgvPriceCache[handle] = { gone: true };
            (byHandle[handle] || []).forEach(function(card) { var li = card.closest('.lgv__card') || card; li.remove(); });
            erledigt();
            next();
            return;
          }
          if (data) {
            lgvPriceCache[handle] = {
              price: data.price,
              formatted: formatMoney(data.price),
              available: data.available
            };
          }
          (byHandle[handle] || []).forEach(function(card) {
            applyToCard(card, data);
          });
          erledigt();
          next();
        })
        .catch(function() {
          (byHandle[handle] || []).forEach(function(card) {
            applyToCard(card, null);
          });
          erledigt();
          next();
        });
    }
    for (var i = 0; i < Math.min(CONCURRENCY, pending.length); i++) next();
  }

  function boot() {
    document.querySelectorAll('[data-lgv-root], [data-lgv-drawer-root]').forEach(init);
  }

  // FIX Bug 2: MutationObserver für per AJAX nachgeladene Produkte (Load-More)
  function observeNewProducts() {
    if (typeof MutationObserver === 'undefined') return;
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      var hasNewRoots = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.hasAttribute && (node.hasAttribute('data-lgv-drawer-root') || node.hasAttribute('data-lgv-root'))) ||
            (node.querySelector && node.querySelector('[data-lgv-drawer-root],[data-lgv-root]'))
          ) {
            hasNewRoots = true;
            break;
          }
        }
        if (hasNewRoots) break;
      }
      if (hasNewRoots) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(boot, 80);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      boot();
      observeNewProducts();
    });
  } else {
    boot();
    observeNewProducts();
  }
  document.addEventListener('shopify:section:load', boot);

  window.LeonGroupifyVariants = { boot: boot };
})();